import { RegisterInfo } from '../types/Helsenorge.Helseregistre.InternalAPI.EntitiesEntities';

export const getRegisterNavn = (navn: string | null, forkortelse: string | null): string => {
  const navnRegister = navn ?? '';
  return forkortelse && forkortelse !== navn ? `${navn} (${forkortelse})` : navnRegister;
};

export const getRegisterInfoTitle = (registerInfo: RegisterInfo | null): string | null => {
  if (!registerInfo || !registerInfo.Navn) {
    return null;
  }
  return getRegisterNavn(registerInfo.Navn, registerInfo.Forkortelse);
};
